<template>
  <ElementsSection :title="$t('comments.title')" data-item="Comments">
    <Swiper
      :modules="[Navigation]"
      :navigation="{
        prevEl: '[data-carousel-button=comments][data-carousel-button-prev]',
        nextEl: '[data-carousel-button=comments][data-carousel-button-next]',
        disabledClass: 'disabled'
      }"
      slides-per-view="auto"
      :space-between="8"
      :auto-height="true"
      :breakpoints="{
        640: { slidesPerView: 2, spaceBetween: 16, autoHeight: false },
        1024: { slidesPerView: 3, spaceBetween: 20 },
        1280: { slidesPerView: 4, spaceBetween: 20 }
      }"
      class="comments"
    >
      <SwiperSlide v-for="(item, index) in data" :key="index" class="comments-item select-none">
        <div class="comments-item__heading">
          <div class="comments-item__heading-name">{{ item.name }}</div>
          <div class="comments-item__heading-star">
            <Icon v-for="i in item.stars" :key="`filled-${i}`" name="ri:star-fill" />
            <Icon v-for="i in 5 - item.stars" :key="`empty-${i}`" name="ri:star-fill" class="opacity-20" />
          </div>
        </div>
        <div class="comments-item__message">{{ item.text }}</div>
        <a class="comments-item__link" :href="item.link" target="_blank" rel="noreferrer">
          <span>{{ $t('comments.readMore') }}</span>
          <Icon name="ri:arrow-right-line" />
        </a>
      </SwiperSlide>
    </Swiper>

    <template #actions>
      <ElementsCarouselButton name="comments" />
    </template>
  </ElementsSection>
</template>

<script setup lang="ts">
  import { Swiper, SwiperSlide } from "swiper/vue"
  import { Navigation } from "swiper/modules"
  import "swiper/css"
  import "swiper/css/navigation"

  import fetchApi from "~/utils/fetchApi"

  const { data: responseData } = await useAsyncData("testimonials", () =>
    fetchApi<any>("testimonials", {
      wrappedByKey: "data"
    })
  )

  const data = computed(() => responseData.value || [])
</script>

<style lang="scss" scoped>
  .comments {
    @apply overflow-visible;

    &-item {
      @apply flex flex-col p-6 gap-3 bg-white select-none transition-opacity duration-200;

      &__heading {
        @apply flex items-center justify-between;

        &-name {
          @apply font-display text-black text-sm leading-4 font-bold;
        }
        &-star {
          @apply flex gap-0.5 text-3;
          color: #e49e48;
        }
      }
      &__message {
        @apply line-clamp-5 text-sm;
        color: #2a3a46;
      }
      &__link {
        @apply flex items-center justify-between text-sm font-semibold leading-none;
        color: #c5a47e;

        :deep(svg) {
          @apply opacity-0 transition-all duration-300 -translate-x-4 text-4;
        }

        &:hover {
          :deep(svg) {
            @apply opacity-100 translate-x-0;
          }
        }
      }

      &:not(.swiper-slide-visible) {
        //@apply opacity-60;
      }
    }

    @include media("sm") {
      &-item {
        @apply p-4;
        width: 80%;

        &__message {
          @apply line-clamp-3;
        }
      }
    }
  }
</style>
